import React, {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {MobileBackButton} from './components/header/MobileBackButton'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {InviteUsers, ThemeModeProvider, UpgradePlan,} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import TrackVASContext from "../../app/TrackVASContext";
import {TrackVASToolbarWrapper} from "./components/toolbar/TrackVASToolbarWrapper";
import {useAuth} from "../../app/modules/auth";

const MasterLayout = () => {
    const location = useLocation();
    const [baseData, setBaseDataSuper] = useState({});
    const {currentUser} = useAuth();

    useEffect(() => {
        reInitMenu()
    }, [location.key]);

    function setBaseData (data:any) {
        let dataFinal = {...baseData, ...data}
        setBaseDataSuper (dataFinal);
    }

    return (
        <PageDataProvider>
            <ThemeModeProvider>
                <TrackVASContext.Provider value={
                    {baseData, setBaseData}
                }>
                    <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
                        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
                            {/*<ReactTooltip place="top" type="dark" effect="solid" html={true}/>*/}

                            <HeaderWrapper/>

                            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                                <Sidebar/>
                                <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                                    <div className='d-flex flex-column flex-column-fluid'>
                                        <TrackVASToolbarWrapper/>

                                        {currentUser?.billingStatus === 'WARNING' && (
                                            <div className='d-flex align-items-center mx-5 mt-2 mb-0 px-4 py-2 rounded' style={{backgroundColor: '#fff3cd', border: '1px solid #ffecb5'}}>
                                                <i className='fa fa-exclamation-triangle fs-6 me-2' style={{color: '#997404'}}></i>
                                                <span className='fw-semibold fs-7' style={{color: '#664d03'}}>
                                                    Your organization has pending payments. Please clear the dues at the earliest to avoid account suspension.
                                                </span>
                                            </div>
                                        )}

                                        {currentUser?.billingStatus === 'SUSPENDED' && (
                                            <div className='d-flex align-items-center mx-5 mt-2 mb-0 px-4 py-2 rounded' style={{backgroundColor: '#f8d7da', border: '1px solid #f5c2c7'}}>
                                                <i className='fa fa-ban fs-6 me-2' style={{color: '#842029'}}></i>
                                                <span className='fw-semibold fs-7' style={{color: '#842029'}}>
                                                    Your organization account has been suspended due to pending payments. Please contact the administrator.
                                                </span>
                                            </div>
                                        )}

                                        <Content>
                                            <Outlet/>
                                        </Content>
                                    </div>
                                    <FooterWrapper/>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* begin:: Drawers */}
                    {/*<ActivityDrawer/>*/}
                    {/*<RightToolbar/>*/}
                    {/*<DrawerMessenger/>*/}
                    {/* end:: Drawers */}

                    {/* begin:: Modals */}
                    <InviteUsers/>
                    <UpgradePlan/>
                    {/* end:: Modals */}
                    <ScrollTop/>
                    <MobileBackButton/>
                </TrackVASContext.Provider>
            </ThemeModeProvider>
        </PageDataProvider>
    )
};

export {MasterLayout}
